import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import $ from "jquery";
import Swal from "sweetalert2";
import LoaderAHSF from "../../Components/LoaderAHSF";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";

import TextAreaAHSF from "../../Components/TextAreaAHSF";
import {
  AddChallengesEncounteredThatAffectedData,
  GetOneChallengesEncounteredThatAffected,
  restValidateChallengesEncounteredThatAffected,
  UpdateGetListChallengesEncounteredThatAffectedData,
  ValidateChallengesEncounteredThatAffected,
} from "../../Redux/Reducers/ReportStage/ChallengesEncounteredThatAffected";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../Services/Account/EncryptionParams";

const AddEditChallengesEncountered = (props) => {
  const dispatch = useDispatch();
  let { stageGuid } = useParams();

  stageGuid = decryptToken(stageGuid);
  const state = useSelector((state) => {
    return {
      //////////////////////////////////////////////////////////

      OneChallengesEncounteredThatAffected:
        state.ChallengesEncounteredThatAffected
          .OneChallengesEncounteredThatAffected,
      UpdateChallengesEncounteredThatAffected:
        state.ChallengesEncounteredThatAffected
          .UpdateChallengesEncounteredThatAffected,
      ChallengesEncounteredThatAffectedValidate:
        state.ChallengesEncounteredThatAffected
          .ChallengesEncounteredThatAffectedValidate,
      loadingOneChallengesEncounteredThatAffected:
        state.ChallengesEncounteredThatAffected
          .loadingOneChallengesEncounteredThatAffected,
    };
  });

  console.log(state.ChallengesEncounteredThatAffectedValidate, "hhh");

  // State for the project admin form

  const [ChallengesEncounteredList, setChallengesEncounteredList] = useState({
    pR_challengesEncounteredThatAffectedId:
      state.OneChallengesEncounteredThatAffected
        ?.pR_challengesEncounteredThatAffectedId,
    challengeDetails:
      state.OneChallengesEncounteredThatAffected?.challengeDetails,
    challengeCause: state.OneChallengesEncounteredThatAffected?.challengeCause,
    suggestedSolutions:
      state.OneChallengesEncounteredThatAffected?.suggestedSolutions,

    pR_ReportsStagesGuid: stageGuid,
  });

  // Function to update an existing project management team member

  const AddChallengesEncountered = async () => {
    const validationList = await dispatch(
      ValidateChallengesEncounteredThatAffected({
        challengeDetails: ChallengesEncounteredList.challengeDetails,
        challengeCause: ChallengesEncounteredList.challengeCause,
        suggestedSolutions: ChallengesEncounteredList.suggestedSolutions,
      })
    );
    //console.log(validationList, validationList.payload.length, "bnbnmbnmb");
    // If no validation errors, add team member
    if (validationList.payload.length === 0) {
      await dispatch(
        AddChallengesEncounteredThatAffectedData({
          challengeDetails: ChallengesEncounteredList.challengeDetails,
          challengeCause: ChallengesEncounteredList.challengeCause,
          suggestedSolutions: ChallengesEncounteredList.suggestedSolutions,
          pR_ReportsStagesGuid: ChallengesEncounteredList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم اضافة المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };

  const UpdateChallengesEncountered = async () => {
    const validationList = await dispatch(
      ValidateChallengesEncounteredThatAffected({
        challengeDetails: ChallengesEncounteredList.challengeDetails,

        challengeCause: ChallengesEncounteredList.challengeCause,
        suggestedSolutions: ChallengesEncounteredList.suggestedSolutions,
      })
    );
    // If no validation errors, update team member
    if (validationList.payload.length === 0) {
      await dispatch(
        UpdateGetListChallengesEncounteredThatAffectedData({
          pR_challengesEncounteredThatAffectedId:
            ChallengesEncounteredList.pR_challengesEncounteredThatAffectedId,
          challengeDetails: ChallengesEncounteredList.challengeDetails,
          challengeCause: ChallengesEncounteredList.challengeCause,
          suggestedSolutions: ChallengesEncounteredList.suggestedSolutions,

          pR_ReportsStagesGuid: ChallengesEncounteredList.pR_ReportsStagesGuid,
        })
      );
      $(".close-btn").trigger("click");
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم تعديل المعلومات بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      dispatch(setRefreshTable());
    }
  };
  useEffect(() => {
    dispatch(restValidateChallengesEncounteredThatAffected());
  }, []);
  useEffect(() => {
    if (props != null) {
      dispatch(
        GetOneChallengesEncounteredThatAffected(
          props.pR_challengesEncounteredThatAffectedId
        )
      );
    }
  }, [props.pR_challengesEncounteredThatAffectedId]);
  useEffect(() => {
    if (
      !state.loadingOneChallengesEncounteredThatAffected &&
      Object.keys(props).length != 0
    ) {
      setChallengesEncounteredList({
        ...state.OneChallengesEncounteredThatAffected,
      });
    } else {
      setChallengesEncounteredList({
        challengeDetails: null,
        challengeCause: null,
        suggestedSolutions: null,
        pR_ReportsStagesGuid: ChallengesEncounteredList.pR_ReportsStagesGuid,
      });
    }
  }, [state.OneChallengesEncounteredThatAffected]);

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  //to render html after loading ends
  return (
    <>
      {!state.loadingOneChallengesEncounteredThatAffected ? (
        <>
          <div className="AddEdite">
            <TextAreaAHSF
              fieldsName="ChallengeDetails"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setChallengesEncounteredList({
                  ...ChallengesEncounteredList,
                  challengeDetails: e.target.value,
                });
              }}
              defaultValue={ChallengesEncounteredList?.challengeDetails}
              showValidationMessage={
                state.ChallengesEncounteredThatAffectedValidate
                  ? state.ChallengesEncounteredThatAffectedValidate.includes(
                      "ChallengeDetails"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="ChallengeCause"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setChallengesEncounteredList({
                  ...ChallengesEncounteredList,
                  challengeCause: e.target.value,
                });
              }}
              defaultValue={ChallengesEncounteredList?.challengeCause}
              showValidationMessage={
                state.ChallengesEncounteredThatAffectedValidate
                  ? state.ChallengesEncounteredThatAffectedValidate.includes(
                      "ChallengeCause"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            <TextAreaAHSF
              fieldsName="suggestedSolutions"
              show={true}
              disabled={props.shouldDisableFields}
              onChange={(e) => {
                setChallengesEncounteredList({
                  ...ChallengesEncounteredList,
                  suggestedSolutions: e.target.value,
                });
              }}
              defaultValue={ChallengesEncounteredList?.suggestedSolutions}
              showValidationMessage={
                state.ChallengesEncounteredThatAffectedValidate
                  ? state.ChallengesEncounteredThatAffectedValidate.includes(
                      "suggestedSolutions"
                    )
                  : false
              }
              validationMessage="يرجى تعبئة هذا الحقل"
            />
            {!props.shouldDisableFields ? (
              <div className="containersButton">
                <div>
                  <ButtonAHSF
                    type={"submitter"}
                    onClick={() => {
                      props.canEdit == "edit"
                        ? UpdateChallengesEncountered()
                        : AddChallengesEncountered();
                    }}
                    disabled={false}
                    title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    text={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
                    show={true}
                  />
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )}
      <LoaderAHSF show={state.loadingOneChallengesEncounteredThatAffected} />
    </>
  );
};

export default AddEditChallengesEncountered;
